import { uiText } from '../../i18n';
import { SwitchRow } from '../../ui/SwitchRow';
import { StudioIcon } from './StudioIcon';
import type { CircleFormState } from './circle/CircleFieldInput';

export function StudioUploadRights({ state }: { state: CircleFormState }) {
  return (
    <SwitchRow
      title={uiText('Права на материалы')}
      description={uiText('Только свои файлы или с согласия владельца')}
      icon={<StudioIcon kind="photo" />}
      checked={state.rights}
      disabled={state.locked}
      onChange={state.setRights}
    />
  );
}
